import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const parts = token.split(".");
  if (parts.length !== 3) return null;
  const payload = parts[1];
  if (!payload) return null;
  const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), "=");
  try {
    return JSON.parse(atob(padded)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function useAccessTokenClaims(): Record<string, unknown> | null {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [claims, setClaims] = useState<Record<string, unknown> | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setClaims(null);
      return;
    }
    let cancelled = false;
    getAccessTokenSilently()
      .then((token) => {
        if (cancelled) return;
        setClaims(decodeJwtPayload(token));
      })
      .catch(() => {
        if (!cancelled) setClaims(null);
      });
    return () => {
      cancelled = true;
    };
  }, [getAccessTokenSilently, isAuthenticated]);

  return claims;
}
